export default __webpack_public_path__ + "static/media/pic5.7eb54729.jpg";